var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullseyePointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 15.0625L29.3125 18.875C30.25 19.125 30.3125 20.4375 29.4375 20.875L25.1875 22.9375L30.75 28.5C31.125 28.875 31.125 29.5 30.75 29.875L29.375 31.25C29 31.625 28.375 31.625 28 31.25L22.4375 25.6875L20.375 29.9375C19.9375 30.8125 18.625 30.75 18.375 29.8125L14.5625 16.375C14.3125 15.5625 15.0625 14.875 15.875 15.0625ZM14.1875 22.375L15.0625 25.5C10.0625 25.25 6 21.125 6 16C6 10.75 10.25 6.5 15.5 6.5C20.625 6.5 24.75 10.5625 25 15.5625L21.875 14.6875C21.25 11.75 18.625 9.5 15.5 9.5C11.9375 9.5 9 12.4375 9 16C9 19.125 11.25 21.75 14.1875 22.375ZM15.5 0.5C24.0625 0.5 31 7.5 31 16C31 16.5 31 16.9375 30.9375 17.375C30.75 17.25 30.5 17.125 30.25 17.0625L28 16.4375C28 16.3125 28 16.1875 28 16C28 9.125 22.4375 3.5 15.5 3.5C8.625 3.5 3 9.125 3 16C3 22.9375 8.625 28.5 15.5 28.5C15.6875 28.5 15.8125 28.5 15.9375 28.5L16.5625 30.75C16.625 31 16.75 31.25 16.875 31.4375C16.4375 31.5 16 31.5 15.5 31.5C7 31.5 0 24.5625 0 16C0 7.5 7 0.5 15.5 0.5Z",
    fill: "#F15B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseyePointer);
export default __webpack_public_path__ + "static/media/bullseye-pointer.e8c2cf05c26dc0cecdcfa4886fbf6a67.svg";
export { ForwardRef as ReactComponent };